import React, { useRef } from 'react'
import { FormattedHTMLMessage } from 'react-intl'

import { StyledTextPage } from '././TextPage.styled'
const TextPage = ({ intlKey, styling, titleID, textID, img, alt, width, children, textLayout }) => {
  const textPageRef = useRef()
  return (
    <StyledTextPage ref={textPageRef} styling={styling} textLayout={textLayout}>
      {titleID && (
        <h2>
          <FormattedHTMLMessage
            id={intlKey + titleID}
            key={intlKey + titleID}
          />
        </h2>
      )}
      {textID && (
        <p>
          <FormattedHTMLMessage
            id={intlKey + textID}
            key={intlKey + textID}
          />
        </p>
      )}
      {img && (<img src={`image/${img}`} alt={alt} width={width} />)}
      {children}
    </StyledTextPage>
  )
}

export default TextPage
